<template>

    <div class="page support-page">
        <v-container class="content-container">
            <section v-if="appData.crisp_website_id" class="my-5 my-lg-8 text-center">
                <h1 class="font-weight-bold primary--text headline d-flex justify-center align-center mb-3">
                    <v-icon size="32" color="primary" class="me-3">mdi-message-processing-outline</v-icon>
                    <span>تواصل معنا</span>
                </h1>
                <div class="details-text text-center muted--text mb-6 mb-lg-8">إذا كانت لديك مشكلة؛ يمكنك التحدث إلى خدمة العملاء لدينا</div>
                <div>
                    <crisp-chat :user="user" :websiteId="appData.crisp_website_id" />
                </div>
            </section>
            <section v-else class="my-5 my-lg-8">
                <h1 class="font-weight-bold primary--text headline d-flex justify-center align-center mb-6 mb-lg-8">
                    <v-icon size="32" color="primary" class="me-3">mdi-help-circle</v-icon>
                    <span>إرسال طلب مساعدة</span>
                </h1>
                <div class="d-flex justify-center">
                    <v-card class="transparent" style="max-width: 700px" flat>
                        <v-card-text class="pb-3 px-lg-8 px-0 pt-0">
                            <form @submit.prevent="submitAction">
                                <v-row>
                                    <template v-if="!isAuthed">
                                        <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                            <v-text-field prepend-inner-icon="mdi-account" outlined hide-details v-model="name" label="الاسم" placeholder="أدخل اسمك بالكامل" />
                                        </v-col>
                                        <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                            <v-text-field prepend-inner-icon="mdi-email" outlined hide-details v-model="email" label="البريد اﻹلكتروني" placeholder="أدخل البريد اﻹلكتروني" />
                                        </v-col>
                                        <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                            <v-text-field prepend-inner-icon="mdi-phone" outlined hide-details v-model="phone" label="رقم الهاتف" placeholder="أدخل رقم الهاتف" />
                                            <v-divider class="mt-6" />
                                        </v-col>
                                    </template>
                                    <v-col :cols="pcOnly ? 12 : 12" class="mb-2 mb-lg-0">
                                        <v-text-field prepend-inner-icon="mdi-text" outlined hide-details v-model="title" label="عنوان الموضوع" placeholder="أدخل عنوان الموضوع" />
                                    </v-col>
                                    <v-col cols="12" class="mb-2 mb-lg-0">
                                        <v-textarea ref="contentInput" rows="6" no-resize outlined hide-details v-model="content"  label="وصف الموضوع" placeholder="أدخل وصف الموضوع"/>
                                    </v-col>
                                    <v-col cols="12" class="d-flex">
                                        <v-spacer />
                                        <v-btn v-if="pcOnly" depressed color="muted" text outlined large :disabled="loading" class="me-2 px-10" @click="reset">إعادة</v-btn>
                                        <v-btn :block="phoneOnly" depressed color="primary" large :loading="loading" :disabled="loading" class="px-12" @click="submitAction">إرسال إلى الدعم</v-btn>
                                    </v-col>
                                </v-row>
                            </form>
                            <template v-if="enableAccountDeletion && isAuthed">
                                <v-divider class="my-5"></v-divider>
                                <div>
                                    <h3 class="font-weight-bold strong-text--text d-flex justify-center align-center mb-2 mb-lg-3">
                                        <v-icon size="23" color="error" class="me-3">mdi-delete</v-icon>
                                        <span>حذف الحساب</span>
                                    </h3>
                                    <p class="text-center details-text muted--text">اضغط على الزر التالي لإرسال طلب حذف حساب إلى الدعم، قد تستغرق عملية حذف الحساب من 24 ساعة إلى 48 ساعة لكي يتم حذف حسابك وبياناتك.</p>
                                    <v-btn outlined block color="error" class="mb-4" @click="deleteAccountClicked">
                                        <v-icon>mdi-delete-outline</v-icon>
                                        <span>طلب حذف الحساب</span>
                                    </v-btn>
                                </div>

                            </template>
                            <v-divider class="my-5"></v-divider>
                            <div>
                                <social-btns colored small />
                            </div>
                        </v-card-text>
                    </v-card>

                    <v-dialog v-model="confirmDialog" max-width="350" overlay-color="#000" overlay-opacity="0.9" persistent>
                        <v-card class="px-2 pb-1">
                            <v-card-title>تأكيد الإرسال إلى الدعم</v-card-title>
                            <v-card-text class="text--text mt-3">هل أنت متأكد من إرسال الطلب إلى الدعم؟</v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="muted" text @click="title = ''; content = ''; confirmDialog = false;">إلغاء</v-btn>
                                <v-btn color="primary" :loading="loading" text @click="submitAction">تأكيد</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
            </section>
            

        </v-container>
        <div class="mt-6">
            <slot v-if="!isAuthed" name="footer" />
        </div>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import SocialBtns from '@/components/main/social-btns'
import CrispChat from '@/components/custom/crisp-chat.vue'

export default {
    components: {
        SocialBtns,
        CrispChat
    },
    
    data(){
        return {
            loading: false,
            confirmDialog: false,
            
            name: '',
            email: '',
            phone: '',

            title: '',
            content: '',
            sentTicket: null,
        }
    },
    computed: {
        enableAccountDeletion(){
            return process.env.VUE_APP_ENABLE_ACCOUNT_DELETION === true || process.env.VUE_APP_ENABLE_ACCOUNT_DELETION === 'true';
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        validate(){
            if (this.title.trim() && this.content.trim()){
                if (this.isAuthed || (this.name.trim() && this.email.trim() && this.phone.trim())){
                    let data = {
                        title: this.title,
                        content: this.content,
                    };
                    if (!this.isAuthed){
                        data.name = this.name;
                        data.email = this.email;
                        data.phone = this.phone;
                    }
                    return data;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        },
        deleteAccountClicked(){
            this.confirmDialog = true;
            this.title = 'حذف الحساب';
            this.content = 'يُرجى حذف الحساب الخاص بي';
        },
        reset(){
            this.phone = '';
            this.name = '';
            this.email = '';
            this.title = '';
            this.content = '';
        },
        submitAction(){
            if (!this.loading){
                this.sentTicket = null;
                let data = this.validate();
                if (data){
                    this.loading = true;

                    this.$store.dispatch('fastPostAction', {url: `/support-tickets`, data}).then((response)=>{
                        let id = response.data.data.id;
                        this.showMsg('تم إرسال رسالتك إلى الدعم، رقم الطلب #' + id, 'success');
                        this.loading = false;
                        this.sentTicket = id;
                        this.reset();
                        this.confirmDialog = false;
                        
                    }).catch((e)=>{
                        this.showMsg("حدثت مشكلة أثناء اﻹرسال");
                        this.loading = false;
                        this.confirmDialog = false;
                    })

                }else{
                    this.showMsg("لا يمكنك ترك حقل فارغاً");
                }
            }
        },
        ...GlobalMethods
    },
    mounted(){
        
    }
}
</script>

<style lang="scss" scoped>

.search-input{
    width: 280px!important;
    max-width: none!important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.search-btn{
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: none;
}

</style>
<style lang="scss">


.theme--light.v-tabs > .v-tabs-bar{
    background-color: unset!important;
    .v-tab{
        font-weight: bold;
        letter-spacing: 0!important;
    }
}

</style>